import { Connection } from 'utils';
import { GET_AGENT_ALL_WALLETS } from 'constants/api';

export default {
  getAgentAllWallets: () => Connection.get(GET_AGENT_ALL_WALLETS),
};
